import { queryOne } from '../../shared/technical/rest/restApi';
import { MqttConfiguration } from './MqttConfiguration';
import { AxiosInstance } from 'axios';

export function getMqttConfiguration(customAxios: AxiosInstance): Promise<MqttConfiguration> {
    return queryOne<MqttConfiguration>(customAxios, 'mqtt-configuration');
  }
